// Default number of days worth of changes
export const DEFAULT_CHANGE_RANGE = 1;
export const MIN_CHANGE_RANGE = 1;
export const MAX_CHANGE_RANGE = 7;
